<template>
  <table class="table table-striped table-bordered text-center">
    <thead class="table-light">
    <tr>
      <th v-if="environment.user_is_admin" scope="col">Orden</th>
      <th scope="col"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="nameHelp">Nombre &#9432;</span></th>
      <th scope="col"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="activeHelp">Activo &#9432;</span></th>
      <th scope="col" width="7%" ><span data-bs-toggle="tooltip" data-bs-placement="top" :title="languagesHelp">Idiomas &#9432;</span></th>
      <th scope="col" width="7%" ><span data-bs-toggle="tooltip" data-bs-placement="top" :title="validDatesHelp">Fechas de validez &#9432;</span></th>
      <th scope="col" width="8%" ><span data-bs-toggle="tooltip" data-bs-placement="top" :title="userCountryHelp">Paises de origen &#9432;</span></th>
      <th scope="col" width="5%" ><span data-bs-toggle="tooltip" data-bs-placement="top" :title="cssClassHelp">Clase CSS &#9432;</span></th>
      <th scope="col" width="5%" ><span data-bs-toggle="tooltip" data-bs-placement="top" :title="mobileHelp">Mobile &#9432;</span></th>
      <th scope="col" width="5%" ><span data-bs-toggle="tooltip" data-bs-placement="top" :title="desktopHelp">Desktop &#9432;</span></th>
      <th scope="col" width="5%" ><span data-bs-toggle="tooltip" data-bs-placement="top" :title="tabletHelp">Tablet &#9432;</span></th>
      <th scope="col" width="6%" ><span data-bs-toggle="tooltip" data-bs-placement="top" :title="noFollowHelp">No follow &#9432;</span></th>
      <th scope="col">Editar</th>
      <th v-if="environment.user_is_admin" scope="col">Eliminar</th>
    </tr>
    </thead>
    <tbody>
      <menus-items-table-row
              v-for="item in menu.items"
              :menu="menu"
              :item="item"
              :key="item.id"
              :environment="environment"
              @delete_menu_item="onDeleteMenuItem"
              @move="onMoveMenuItem"
      />
    </tbody>
  </table>
</template>

<script>
import HelpTexts from '@/utils/HelpTexts.js'
import MenusItemsTableRow from '@/components/Tables/MenusItemsTableRow.vue'

export default {
    name: 'menus-items-table',
    emits: ['delete_menu_item', 'move'],
    components: {
      'menus-items-table-row' : MenusItemsTableRow
    },
    props: {
      menu: {
        type: Object,
        default: {}
      },
      environment: {
        type: Object,
        default: {}
      }
    },
    computed: {
      isDisabledHelp: function () {
        return HelpTexts.getItemIsDisabledText();
      },
      nameHelp: function () {
        return HelpTexts.getItemNameText();
      },
      activeHelp: function () {
        return HelpTexts.getItemActiveText();
      },
      cssClassHelp: function () {
        return HelpTexts.getItemCssClassText();
      },
      mobileHelp: function () {
        return HelpTexts.getItemMobileText();
      },
      desktopHelp: function () {
        return HelpTexts.getItemDesktopText();
      },
      tabletHelp: function () {
        return HelpTexts.getItemTabletText();
      },
      noFollowHelp: function () {
        return HelpTexts.getItemNoFollowText();
      },
      targetBlankHelp: function () {
        return HelpTexts.getItemTargetBlankText();
      },
      userCountryHelp: function () {
        return HelpTexts.getItemUserCountryText();
      },
      validDatesHelp: function () {
        return HelpTexts.getItemValidDatesText();
      },
      languagesHelp: function () {
        return HelpTexts.getItemLanguagesText();
      },
    },
    methods : {
      onDeleteMenuItem (menuId) {
        this.$emit('delete_menu_item', menuId);
      },
      onMoveMenuItem (move) {
        this.$emit('move', move);
      }
    },
}
</script>

<style>
  .table {
  margin: auto;
  width: 90% !important;
  }
</style>
